<div class="overlay" *ngIf="showLoader" >
<div  class="loader">
  <mat-spinner strokeWidth="3" diameter="100" color="#000"></mat-spinner>
</div>
</div>

<div class="background">
  <app-search
    [(showAdvanced)]="showAdvanced"
    [(searchFilter)]="searchFilter"
    (showAdvancedEvent)="showAdvancedEvent($event)"
    (filterGrid)="filterGrid($event)"
    [pageSize] = "pageSize"
  ></app-search>

  <h4 class="header">SMTH Slips Review Dashboard</h4>

  <div *ngIf="!showAdvanced">
    <div class="textdesign" *ngIf="!trainingApp">
      <input
        type="text"
        value="Business Unit: {{ userDepotNames }}"
        class="textback"
      />
      <div class="pendefault" (click)="edit()"></div>
    </div>
    <div class="textdesign" *ngIf="trainingApp">
      <input
        type="text"
        value="Business Unit: Training Depot"
        class="textback"
        disabled
      />
    </div>
    <div class="statusdesign ">
      <div class="leftbox">
        <div class="reviewback"></div>
        <h2 class="review" (click)="filterAllList('3')">{{ reviewValue }}</h2>
        <p class="rev" (click)="filterAllList('3')">In Review</p>
      </div>

      <div class="middlebox">
        <div class="submittedback"></div>
        <h2 class="submitted" (click)="filterAllList('1')">
          {{ approveValue }}
        </h2>
        <p class="sub" (click)="filterAllList('1')">Submitted</p>
      </div>
      <div class="middlebox">
        <div class="sent-to-retest-back"></div>
        <h2 class="sent-to-retest" (click)="filterAllList('4')">
          {{ sentToRetest }}
        </h2>
        <p class="sub" (click)="filterAllList('4')">Sent To Retest</p>
      </div>
      <div class="middlebox">
        <div class="unknown-handover"></div>
        <h2 class="sent-to-retest" (click)="filterAllList('8')">
          {{ unknownHandovers }}
        </h2>
        <p class="sub" (click)="filterAllList('8')">Handover Pending</p>
      </div>
    </div>
    <h4 class="headercenter">Submitted Slips</h4>
  </div>
  <div class="btn-row">
    <span class="headertime"
      >Last updated:
      {{ lastUpdatedDateTime | dateFormat: "dd/MM/yyyy, HH:mm" }}</span
    >
    <input
      type="button"
      class="button"
      value="Refresh"
      (click)="refreshGrid()"
    />
    <span class="tagfiltershow" *ngIf="tagsValue">
      <label class="reviewtags">{{ submittedTagsValue }}</label>
      <img
        src="assets/images/close.png"
        (click)="refreshGrid()"
        class="closeimage"
      />
    </span>
    <input
      type="button"
      *ngIf="!isReadOnly"
      class="downloadbutton"
      value="Download Excel"
      (click)="exportexcel()"
    />
    <input
      type="button"
      *ngIf="userHasAccess"
      class="downloadbutton offline-slip"
      value="Add Offline Slip"
      (click)="addOfflineTestslip()"
    />
  </div>
  <section class="table-grid">
    <div class="filter-section">
      <div class="d-flex flex-wrap">
        <app-tag
          *ngFor="let filter of filterTags"
          [categoryName]="getCategoryName(filter)"
          [title]="filter.name"
          [isFilter]="true"
          (removeFilter)="onRemoveFilterTag(filter)"
        >
        </app-tag>
      </div>
      <!-- <button
        *ngIf="showFilterBtn"
        class="nr-button nr-button-sm clr-all"
        (click)="resetDashboardFilter()"
      >
        Clear all filters
      </button> -->
    </div>
    <app-table
      [showLoader]="isLoader"
      [pageLength]="pageLength"
      [isRowClickable]="isRowClickable"
      [columnHeader]="columnHeader"
      [columnRowData]="viewTestSlipData"
      [showUtils]="true"
      [resetTable]="resetTable"
      [showCheckbox]="false"
      [isColumnLevelFilter]="true"
      [showColumnLevelFilter]="showFilter"
      noDataMsg="No results found"
      (paginationInfo)="paginationInfo($event)"
      (checkOrUncheckSelected)="checkOrUncheckSelected($event)"
      (sortedColumnData)="sortedColumnData($event)"
      (selectedRowEvent)="selectedRowEvent($event)"
      (filterClick)="onFilterClick($event)"
      (closeFilterOverlay)="onCloseFilterOverlay($event)"
      (filterData)="onFilterData($event)"
    ></app-table>
  </section>
  <!-- <div
    class="container-fluid data-not-found"
    *ngIf="!viewTestSlipData || viewTestSlipData.length == 0"
  >
    No data found.
  </div> -->

  <app-modal
    *ngIf="modalOpned"
    [modalHeader]="'Select areas to view associated information'"
    (closeModal)="close($event)"
    (apply)="saveRegion()"
  >
    <div class="modal-body">
      <app-user-region #region></app-user-region>
    </div>
  </app-modal>
</div>
<ng-template #actionButtonTemplate_CM let-col="column" let-data="rowData">
  <div *ngIf="getData(data)" class="txt-dsng" [ngClass]="getClass(data)">
    <ng-container>
      <!-- <div (click)="getData(data)">
        Edit
      </div> -->
      <!-- <span>{{ getData(data) }}</span> -->
      <div *ngIf="getData(data) === 'SUBMITTED'">
        <span class="buttonclass">{{ getData(data) }}</span>
      </div>
      <div *ngIf="getData(data) === 'APPROVED'">
        <span class="buttonapprovedclass">{{ getData(data) }}</span>
      </div>
      <div *ngIf="getData(data) === 'IN REVIEW'">
        <span class="buttonreviewclass">{{ getData(data) }}</span>
      </div>
      <div *ngIf="getData(data) === 'SENT TO RETEST'">
        <span class="buttonretestlass">{{ getData(data) }}</span>
      </div>
      <div *ngIf="getData(data) === 'HANDOVER PENDING'">
        <span class="buttonpendignlass">{{ getData(data) }}</span>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #actionDateTemplate_CM let-col="column" let-data="rowData">
  <div class="txt-dsng">
    <ng-container>
      <span class="columncol">{{
        data.testDateTime | dateFormat: "dd/MM/yyyy, HH:mm"
      }}</span>
    </ng-container>
  </div>
</ng-template>

<ng-template #actionLinkTemplate_CM let-col="column" let-data="rowData">
  <div class="txt-dsng">
    <ng-container>
      <span
        class="columncol navigation"
        (click)="navigateToWorkflowPages(data.id)"
        >{{ data.testSlipId }}</span
      >
    </ng-container>
  </div>
</ng-template>

